import type { GettextFn } from "@/types";

export const emailInviteUserToPartnerExisting = (
  gettext: GettextFn,
  partner: { appUrl: string },
) => {
  const loginLink = partner.appUrl;
  return `
    <tr>
      <td>${gettext("Dear {{user_full_name}}")},</td>
    </tr>
    <tr>
        <td>${gettext("You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you click Login to access the system.")}</td>
    </tr>
    <tr>
        <td>
            <a class="link-button" href="${loginLink}" style="color: #FFFFFF">${gettext("Login")}</a>
        </td>
    </tr>
`;
};
